import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSlug from "rehype-slug-custom-id";
import { getMarkdownFile } from "../../services/MarkdownService";
import { markdownLinkClassName } from "../Markdown/Key";

export function PrivacyPolicy() {
    const [privacyPolicy, setPrivacyPolicy] = React.useState("");
    let markdownFile = getMarkdownFile("privacy_policy_en"); // Ignoring i18n language because we currently don't have any translations

    React.useEffect(() => {
        fetch(markdownFile)
            .then((result) => result.text())
            .then((markdownString) => {
                setPrivacyPolicy(markdownString);
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="m-8 md:m-24 styled-markdown">
            <ReactMarkdown
                children={privacyPolicy}
                // Heading ids for the policy's own "#section" links, slugged as in the manual.
                rehypePlugins={[rehypeRaw, [rehypeSlug, { removeAccents: true }]]}
                components={{
                    a({ node, children, ...props }) {
                        return (
                            <a
                                {...props}
                                rel={props.target === "_blank" ? "noreferrer" : props.rel}
                                className={markdownLinkClassName}
                            >
                                {children}
                            </a>
                        );
                    },
                }}
            />
        </div>
    );
}
